var map = {
	"./empty.cart.json": 1111,
	"./empty.catalog.json": 736,
	"./empty.json": 593,
	"./error.json": 592,
	"./message.json": 1112,
	"./order-placed.json": 440,
	"./redirect-page.json": 728
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1110;